import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PhotosViewerPage } from './photos-viewer';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    PhotosViewerPage,
  ],
  imports: [
    IonicPageModule.forChild(PhotosViewerPage),
    ComponentsModule
  ],
})
export class PhotosViewerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/photos-viewer/photos-viewer.module.ts